const shape = {
  borderRadius: 5,
  largeComponentRadius: 10,
  mediumComponentRadius: 5,
  smallComponentRadius: 2
};
export default shape;
//# sourceMappingURL=shape.js.map